import {Breadcrumb} from "antd";
import {useEffect, useState} from "react";
import './DashboardTitle.css'

export function DashboardTile({region}) {
    const [breadcrumbData, setBreadcrumbData] = useState([{'title': '...'}]);

    useEffect(() => {

            const data =
                region ? [
                        {"title": "Carbon footprint simulator"},
                        {"type": "separator"},
                        {"title": region}
                    ]
                    : [
                        {"title": "Carbon footprint simulator"},
                        {"type": "separator"},
                        {"title": 'no region'}
                    ]

            setBreadcrumbData(data)

        },
        [region]
    )
    ;

    return (
        <div className="mapTitle"
             style={{
                 margin: '0 350px'
             }}>
            <div className="mapTitleBox">
                <Breadcrumb
                    separator=""
                    items={breadcrumbData}
                />
            </div>
        </div>
    )
}